<template>
  <div id="CarAutoCreate">
    <!-- success msg component 
    <Success :msg="msg" v-show="success" />
    <ProductForm :user="user" @submit-form="saveUser" hasCustomer=true buttonText="Guardar" />
     -->
    <ProductForm :user="user" :submitForm="addRow" buttonText="Guardar" hasReset=true hasCar=true />
  </div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import ProductForm from "@/components/CarAutoForm";
//import Success from "./Success";
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';
// import router from '@/router';

export default {
  name: "ProductCreate",
  computed:{
    ...mapState(['currentUser']),    
  },
  components: {
    ProductForm,
    //Success,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      success: false,
      msg: "",
    };
  },
  methods: {
    ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
    async addRow(ProductInfo){
      this.showLoading({titulo:"Almacenando información",color:"warning"})
      // alert("Agregar Product"+ProductInfo.brand_id);
      // alert("Agregar Product"+ProductInfo.brand_id);
      try{         
        // let branch_id=this.currentUser.branch_id;
        let brand_id=ProductInfo.brand_id;
        let catcarmodel_id=ProductInfo.catcarmodel_id;
        let catcarversion_id=ProductInfo.catcarversion_id;
        let chasis=ProductInfo.chasis;
        let transmision=ProductInfo.transmision;
        let year=ProductInfo.year;
        let km=ProductInfo.km;
        let price=ProductInfo.price;
        let color_ext=ProductInfo.color_ext;
        let notes=ProductInfo.notes;     
        // let status=ProductInfo.status;
        
        // const { id, branch_id, supplier_id, warehouse_id, product_id, famcategory_id, price,iva,iva_referencia } = this;
        await icheckApi().post(`/autos`,JSON.stringify({ brand_id, catcarmodel_id,catcarversion_id,chasis,transmision,year,km,price,color_ext,notes })).then((response)=>{
            if(!response.data.error){                            
              this.$swal("Genial!",response.data.message, "success");
            }else{
              // this.$swal("Error!",response.data.message, "error");
              this.$swal("Error!",response.data.message+': <br/>'+JSON.stringify(response.data.validate), "error"); 
            }                                    
          });
      }catch(error){
        if (error.message=='Request failed with status code 500') {
          this.$swal("Error!",error.message+"<br/> Intente Nuevamente o verifique todos los campos", "error");    
        }else{
          this.$swal("Error!", "Algo salio mal, Intente nuevamente <br/>"+error, "error");
        }
      }  finally{
        this.hiddenLoading()
      }
      
    
    },
  },
};
</script>